// extracted by mini-css-extract-plugin
export var headerCell = "_6t-1";
export var loadingSpinnerContainer = "_6t-4";
export var rowWrapper = "_6t-3";
export var standaloneTable = "_6t-5";
export var table = "_6t-0";
export var white = "_6t-2";